import { InjectionToken } from '@angular/core';

/**
 * Token for FormLockService (forms app only).
 * Used to optionally inject the service in shared components.
 */
export interface FormLockServiceInterface {
  isLocked(): boolean;
  isLocked$: import('rxjs').Observable<boolean>;
  lock(): void;
  unlock(): void;
  toggle(): void;
  setLockedFormRoute(workspaceId: string, sessionId: string, formId: string): void;
  getLockedFormRoute(): {
    workspaceId: string;
    sessionId: string;
    formId: string;
  } | null;
  clearLockedFormRoute(): void;
}

export const FORM_LOCK_SERVICE_TOKEN = new InjectionToken<FormLockServiceInterface>(
  'FORM_LOCK_SERVICE',
);
